module.exports = __webpack_public_path__ + "img/motorcycle-photo-05.9ea41338.jpg";